import dayjs from 'dayjs';

import { DateRange, Filters } from '@app/components/UI/Filters/FilterHook';
import { isDateRange } from '@app/objects/DateRange';

const format = 'YYYY-MM-DD';

function toString(date: number): string {
	return dayjs(date).format(format);
}

function toQuery(key: string, range: DateRange): string {
	const query: Array<string> = [];

	if (range.from) {
		query.push(`${key}.from=${toString(range.from)}`);
	}
	if (range.to) {
		query.push(`${key}.to=${toString(range.to)}`);
	}

	return query.join('&');
}

export function getQueryParams(filters: Partial<Filters>) {
	const params: Array<string> = [];
	Object.entries(filters).forEach(([key, value]) => {
		if (Array.isArray(value)) {
			params.push(value.map((i) => (`${key}=${i}`)).join('&'));

			return;
		}

		const isDate = key === 'date' || key === 'dueDate';
		if (isDate) {
			if (!value) return;
			if (!isDateRange(value)) return;

			const query = toQuery(key, value as DateRange);
			if (query) {
				params.push(query);
			}

			return;
		}

		params.push(`${key}=${value}`);
	});

	return params.join('&');
}
